<div class="narrow">
    <div
        class="loyalty"
        *ngIf="isMobile && isLoyaltyCardVisible && loyaltyCard.number_card"
    >
        <div
            class="loyalty-card"
            [class.collapsed]="isLoyaltyCardCollapsed"
            [class.card-inactive]="isLoyaltyCardInactive"
        >
            <div class="loyalty-card-left">
                <div class="loyalty-card__number">
                    Карта № {{ loyaltyCard.number_card }}
                </div>

                <!-- Показываем, только если карта активна -->
                <div
                    class="loyalty-card__lvl"
                    *ngIf="loyaltyCard.name_programm && !isLoyaltyCardInactive"
                >
                    {{ loyaltyCard.name_programm }}
                </div>
                <div
                    class="loyalty-card__bonuses"
                    *ngIf="loyaltyCard.bonus_amount && !isLoyaltyCardInactive"
                >
                    {{ loyaltyCard.bonus_amount }}
                    {{ loyaltyCard.bonus_amount | bonusCase }}
                </div>

                <!-- Текст "неактивна" — только если неактивна -->
                <div
                    class="loyalty-card__inactive"
                    *ngIf="isLoyaltyCardInactive"
                >
                    Ваша карта является неактивной
                </div>
            </div>

            <!-- Процент скидки — только если карта активна -->
            <div
                class="loyalty-card-left"
                *ngIf="loyaltyCard.discount && !isLoyaltyCardInactive"
            >
                <div class="loyalty-card__percents">
                    {{ loyaltyCard.discount }} %
                </div>
            </div>
        </div>
    </div>

    <div
        class="app__mobile-page payments-page"
        [class.payments-page__loyalcard]="isLoyaltyCardVisible && isMobile"
    >
        <div class="payments-page__body">
            <app-mobile-feed-page-template
                [count-of-pages]="countOfPages"
                [loaded-pages]="loadedPages"
                [is-loading]="loadingMoreContent"
                [root-url]="'home/payments'"
                [view-page]="viewPage"
                [pages]="this.payPages"
                [no-more-content-text]="'Платежей больше нет.'"
                [is-feed-empty]="this.payPages.length === 0"
                [feed-empty-text]="
                    'На выбранные дни финансовых операций или услуг на оплату нет'
                "
                (load-next-page)="loadNextPage()"
                class="app-payments-feed-page-template"
                *ngIf="!isLoading; else loader"
            >
                <feed-header-period
                    header
                    [periodText]="periodText"
                    (onClick)="showPeriodDialog()"
                    [canBeClear]="periodText != 'Платежи за всё время'"
                    (onClear)="btnFilterByDate(null, null)"
                ></feed-header-period>

                <section
                    page
                    [id]="'page' + (pageIndex + 1)"
                    class="services-mobile__page payments-mobile__page"
                    *ngFor="let payPage of payPages; let pageIndex = index"
                >
                    <!-- [is-hidden]="pageIndex === 0" -->
                    <app-feed-page-anchor
                        class="finance-page--anchor"
                        (intersected)="viewPage = pageIndex + 1"
                    >
                        Страница {{ pageIndex + 1 }} из {{ countOfPages }}
                    </app-feed-page-anchor>

                    <ng-container *ngIf="payPage === null">
                        <div class="no--operation">
                            Здесь появятся финансовые<br />
                            операции и услуги на оплату
                        </div>
                    </ng-container>

                    <ng-container *ngIf="payPage != null">
                        <div
                            class="card--pay"
                            *ngFor="let pay of payPage; let i = index"
                        >
                            <ng-container>
                                <div
                                    class="finanse-content__year"
                                    [class.hidden]="i < 1"
                                    (intersected)="viewPage = i + 1"
                                    *ngIf="isBlockYeer(i)"
                                >
                                    <span>{{ getYeerPc(i) }}</span>
                                </div>
                            </ng-container>

                            <div
                                class="finance-content__item"
                                (click)="showDetailsDialog(pay)"
                            >
                                <div class="finance-content__item-head">
                                    <div class="day">
                                        {{ getNameDay(pay.dtSort) }}
                                    </div>
                                    <div
                                        class="cls-table-td-event"
                                        *ngIf="pay.pt_dat_str"
                                    >
                                        {{ getTekDay(pay.dtSort) }} в
                                        {{ getTime(pay.dtSort) }}
                                    </div>
                                </div>
                                <div class="finance-content__item-title">
                                    {{ pay.pay_type }}
                                </div>
                                <div class="finance-content__item-bottom">
                                    <div>
                                        <div
                                            class="line-limit-length"
                                            *ngIf="!isPay(pay) && !isRefund"
                                        >
                                            <span
                                                *ngIf="pay.services.length > 1"
                                            >
                                                {{ pay.services.length }}
                                                {{
                                                    pay.services.length
                                                        | i18nPlural
                                                            : servicesMapper
                                                }}
                                            </span>
                                            <span
                                                *ngIf="pay.services.length == 1"
                                            >
                                                {{ pay.services[0].name }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="price">
                                        <div
                                            *ngIf="pay.paystatus == 1"
                                            class="finance-content__item-price"
                                        >
                                            {{
                                                pay.all_amount
                                                    | priceSpace : ".2"
                                            }}
                                            рублей
                                        </div>
                                        <div
                                            *ngIf="
                                                pay.paystatus != 1 &&
                                                pay.pay_card != 0 &&
                                                pay.confirmation_url != null
                                            "
                                            class="finance-content__item-price finance-content__item-price-nopay"
                                        >
                                            {{
                                                pay.pay_card | priceSpace : ".2"
                                            }}
                                            рублей
                                        </div>
                                        <div
                                            *ngIf="
                                                pay.paystatus != 1 &&
                                                pay.pay_card != 0 &&
                                                pay.confirmation_url == null
                                            "
                                            class="finance-content__item-price finance-content__item-price-nopay finance-content__item-price--grey"
                                        >
                                            {{
                                                pay.pay_card | priceSpace : ".2"
                                            }}
                                            рублей
                                        </div>
                                        <div
                                            *ngIf="
                                                pay.paystatus != 1 &&
                                                pay.pay_card == 0
                                            "
                                            class="finance-content__item-price finance-content__item-price-nopay"
                                        >
                                            {{
                                                pay.all_amount
                                                    | priceSpace : ".2"
                                            }}
                                            рублей
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="finance-content__item-abs"
                                (click)="actionClick(pay)"
                                *ngIf="pay.all_amount !== 0"
                            >
                                <div
                                    *ngIf="isNotRefundPayment(pay)"
                                    class="payments-table__col payments-table__col--action"
                                >
                                    <ng-container
                                        *ngIf="pay | isRefund; else payTemplate"
                                    >
                                        <div class="refund">
                                            <mat-icon
                                                svgIcon="refund-icon__mobile"
                                                style="
                                                    width: 60px;
                                                    height: 30px;
                                                "
                                            ></mat-icon>
                                        </div>
                                    </ng-container>

                                    <ng-template #payTemplate>
                                        <mat-icon
                                            svgIcon="pay-card__mobile"
                                            style="width: 60px; height: 30px"
                                        ></mat-icon>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div
                            class="payments-bottom-loader"
                            *ngIf="loadingPaymentsList"
                        >
                            <div class="css-spinner"></div>
                            <div class="loader-text">Загрузка платежей...</div>
                        </div>
                    </ng-container>
                </section>

                <div fab class="calendar-btn" (click)="showPeriodDialog()">
                    <mat-icon
                        svgIcon="calendar"
                        style="width: 64px; height: 64px"
                    ></mat-icon>
                </div>
            </app-mobile-feed-page-template>
        </div>
    </div>

    <ng-template #loader>
        <div class="loader">
            <loader type="page" message="Загрузка списка платежей"> </loader>
        </div>
    </ng-template>
</div>

<div class="wide">
    <div class="payments-page">
        <div class="header-combined" *ngIf="!isMobile">
            <div class="header-main">
                <div class="header__buttons">
                    <span class="header__title">Финансы</span>
                    <button
                        class="header__buttons-button"
                        (click)="btnFiltrTek()"
                        [class.selected]="selectedButton === 'today'"
                        [disabled]="
                            loadingPaymentsList || selectedButton === 'today'
                        "
                    >
                        за сегодня
                    </button>
                    <button
                        class="header__buttons-button"
                        (click)="btnFiltr3Day()"
                        [class.selected]="selectedButton === '3days'"
                        [disabled]="
                            loadingPaymentsList || selectedButton === '3days'
                        "
                    >
                        за 3 дня
                    </button>
                    <button
                        class="header__buttons-button"
                        (click)="btnAllDays()"
                        [class.selected]="selectedButton === 'all'"
                        [disabled]="
                            loadingPaymentsList ||
                            (selectedButton === 'all' && !customDateSelected)
                        "
                    >
                        Все
                    </button>
                    <!-- Добавляем компонент date-range -->
                    <div
                        class="payments-page__date-range"
                        [class.highlighted]="customDateSelected"
                    >
                        <app-date-range
                            [dtBegin]="dtBegins"
                            [dtEnd]="dtEnds"
                            (onChanged)="onDateRangeChanged($event)"
                        ></app-date-range>
                    </div>
                </div>

                <div class="header-controls">
                    <div
                        class="loyalty-mini"
                        *ngIf="loyaltyCard.number_card && isLoyaltyCardVisible"
                    >
                        <div
                            class="loyalty-card"
                            [class.card-inactive]="isLoyaltyCardInactive"
                        >
                            <div class="loyalty-card__left">
                                <div class="loyalty-card__number">
                                    Карта лояльности №
                                    {{ loyaltyCard.number_card }}
                                </div>
                                <div
                                    class="loyalty-card__bonuses"
                                    *ngIf="
                                        loyaltyCard.bonus_amount &&
                                        !isLoyaltyCardInactive
                                    "
                                >
                                    {{ loyaltyCard.bonus_amount }}
                                    {{ loyaltyCard.bonus_amount | bonusCase }}
                                </div>
                                <!-- Текст "неактивна" — только если неактивна -->
                                <div
                                    class="loyalty-card__inactive"
                                    *ngIf="isLoyaltyCardInactive"
                                >
                                    Ваша карта является неактивной
                                </div>
                            </div>
                            <div class="loyalty-card__right">
                                <div
                                    class="loyalty-card__lvl"
                                    *ngIf="
                                        loyaltyCard.name_programm &&
                                        !isLoyaltyCardInactive
                                    "
                                >
                                    {{ loyaltyCard.name_programm }}
                                </div>
                                <div
                                    class="loyalty-card__discount"
                                    *ngIf="
                                        loyaltyCard.discount &&
                                        !isLoyaltyCardInactive
                                    "
                                >
                                    {{ loyaltyCard.discount }}%
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            *ngIf="!isLoading && paymentsList; else listLoader"
            class="payments-page__list"
            #paymentsContainer
            (scroll)="onScroll($event)"
        >
            <ng-template
                *ngIf="paymentsListLength > 0; else showNotRec"
                [ngTemplateOutlet]="showTable"
            ></ng-template>

            <ng-template #showNotRec>
                <div class="cls-not-rec">Нет платежей</div>
            </ng-template>

            <ng-template #showTable>
                <div class="payments-table">
                    <div class="payments-table__body">
                        <ng-container
                            *ngFor="let pay of paymentsList; let iPay = index"
                        >
                            <div
                                class="payments-table__year"
                                *ngIf="isBlockYeerPc(iPay)"
                            >
                                {{ getYeer(iPay) }}
                            </div>

                            <div
                                class="payments-table__row"
                                [ngClass]="{
                                    'cls-bg-services':
                                        animateStateServices[iPay] == 'on'
                                }"
                            >
                                <div class="payments-table__col fist-column">
                                    <span class="fist-column-day">
                                        {{ getTekDayPc(pay.dtSort) }} в
                                        {{ getTimePc(pay.dtSort) }}
                                    </span>
                                    <div class="payments-table__day">
                                        {{ getNameDayPc(pay.dtSort) }}
                                    </div>
                                </div>

                                <div class="payments-table__col pay_type">
                                    {{ pay.pay_type }}
                                    <!-- {{ paytypeHandler(pay.pay_type) }} -->
                                </div>

                                <ng-container
                                    *ngIf="
                                        pay.services.length > 1;
                                        then showServices;
                                        else showNotServices
                                    "
                                ></ng-container>

                                <ng-template #showServices>
                                    <div
                                        class="payments-table__col"
                                        *ngIf="pay.services[0].dt"
                                    >
                                        <span class="dtstr">
                                            {{
                                                getPeriodServicesStartEnd(
                                                    pay.services
                                                )
                                            }}
                                        </span>
                                        <span class="dtstr">
                                            -
                                            {{
                                                getPeriodServicesStartEnd(
                                                    pay.services,
                                                    false
                                                )
                                            }}
                                        </span>
                                    </div>
                                    <div class="payments-table__col">
                                        <button
                                            *ngIf="pay.services.length > 1"
                                            class="btn cls-btn-second cls-btn-filter cls-button-n-services"
                                            (click)="
                                                showHideListservicesPc(iPay)
                                            "
                                        >
                                            {{ pay.services.length }}
                                            {{
                                                getStrEndServ(
                                                    pay.services.length
                                                )
                                            }}
                                        </button>
                                    </div>
                                </ng-template>

                                <ng-template #showNotServices>
                                    <div class="payments-table__col dtstr">
                                        <span> Дата визита:</span>
                                        {{ getTekDay(pay.services[0].dt) }}
                                        <br />
                                        {{ getTime(pay.services[0].dt) }}
                                    </div>
                                    <div class="payments-table__col spec_name">
                                        {{ pay.services[0].name }}
                                        <span
                                            *ngIf="pay.services[0].spec_name"
                                            style="margin-right: 5px"
                                        >
                                            -
                                            {{ pay.services[0].spec_name }}
                                        </span>
                                        <span *ngIf="pay.services[0].doc">
                                            ({{ pay.services[0].doc }})
                                        </span>
                                    </div>
                                </ng-template>

                                <div
                                    class="payments-table__col--price"
                                    [ngClass]="{
                                        'cls-table-td-priceToPay': isPayPc(pay)
                                    }"
                                >
                                    {{ pay.all_amount | priceSpace : ".2" }}
                                    руб
                                </div>
                                <div class="button__container">
                                    <div
                                        class="button__container"
                                        (click)="actionClick(pay)"
                                        *ngIf="pay.all_amount !== 0"
                                    >
                                        <div
                                            *ngIf="isNotRefundPayment(pay)"
                                            class="payments-table__col payments-table__col--action"
                                        >
                                            <ng-container
                                                *ngIf="
                                                    pay | isRefund;
                                                    else payTemplate
                                                "
                                            >
                                                <div class="refund">
                                                    <mat-icon
                                                        svgIcon="refund-icon"
                                                        style="
                                                            width: 60px;
                                                            height: 30px;
                                                        "
                                                    ></mat-icon>
                                                </div>
                                            </ng-container>

                                            <ng-template #payTemplate>
                                                <mat-icon
                                                    svgIcon="pay-card"
                                                    style="
                                                        width: 60px;
                                                        height: 30px;
                                                    "
                                                ></mat-icon>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-container
                                *ngIf="animateStateServices[iPay] == 'on'"
                            >
                                <div
                                    class="payments-table__row payments-table__row--service"
                                    [@heightAnimation]="
                                        animateStateServices[iPay]
                                    "
                                    *ngFor="
                                        let ps of pay.services;
                                        let is = index
                                    "
                                    [ngClass]="{
                                        'tr-serv-end':
                                            is == pay.services.length - 1
                                    }"
                                >
                                    <div class="payments-table__col"></div>
                                    <div class="payments-table__col"></div>
                                    <div class="payments-table__col">
                                        {{ getTekDay(ps.dt) }} в
                                        {{ getTime(ps.dt) }}
                                    </div>
                                    <div class="payments-table__col">
                                        {{ ps.name }}
                                        <span
                                            *ngIf="ps.spec_name"
                                            style="margin-right: 5px"
                                        >
                                            - {{ ps.spec_name }}
                                        </span>
                                        <span *ngIf="ps.doc">
                                            ({{ ps.doc }})
                                        </span>
                                    </div>
                                    <div
                                        class="payments-table__col payments-table__col--service-price"
                                    >
                                        {{ ps.price | priceSpace : ".2" }}
                                        руб
                                    </div>
                                    <div class="payments-table__col"></div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-template>
            <!-- </app-panel-table-pagination> -->
        </div>
        <div class="visits__footer">
            <div class="visits__footer-content">
                <div class="payments-bottom-loader" *ngIf="loadingMoreContent">
                    <div class="css-spinner"></div>
                    <div class="loader-text">Загрузка платежей...</div>
                </div>
                <span class="visits__footer-text">
                    Записей {{ (paymentsList || []).length }} из
                    {{ paymentsListLength || 0 }}
                </span>
                <div class="visits__footer-progress">
                    <div
                        class="visits__footer-progress-bar"
                        [style.width.%]="
                            paymentsListLength > 0
                                ? ((paymentsList || []).length /
                                      paymentsListLength) *
                                  100
                                : 0
                        "
                    ></div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #listLoader>
        <div class="loader panel">
            <loader
                type="page"
                [isFullscreen]="true"
                message="Загрузка списка платежей..."
            ></loader>
        </div>
    </ng-template>

    <ng-template #payLoader>
        <div class="loader panel">
            <loader
                type="page"
                [isFullscreen]="true"
                message="Сейчас вы будете перенаправлены в платежную систему"
            ></loader>
        </div>
    </ng-template>
</div>
